import React, { useState } from 'react';
import axios from '../api/axios';

export default function ReportsAbsences() {
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');
  const [records, setRecords] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSearch = async (event) => {
    event.preventDefault();
    setError(null);

    if (from && to && from > to) {
      setError('La fecha inicial no puede ser mayor que la final.');
      return;
    }

    setIsLoading(true);
    try {
      const params = {};
      if (from) {
        params.from = from;
      }
      if (to) {
        params.to = to;
      }
      const response = await axios.get('/absences/report', { params });
      setRecords(response.data);
    } catch (err) {
      const message = err.response?.data?.message || 'No se pudieron cargar las ausencias.';
      setError(message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDownloadPdf = async () => {
    setError(null);
    if (from && to && from > to) {
      setError('La fecha inicial no puede ser mayor que la final.');
      return;
    }
    try {
      const params = {};
      if (from) {
        params.from = from;
      }
      if (to) {
        params.to = to;
      }
      const response = await axios.get('/absences/report/pdf', {
        params,
        responseType: 'blob',
      });
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `ausencias_${from || 'todas'}_${to || 'todas'}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      const message = err.response?.data?.message || 'No se pudo descargar el PDF.';
      setError(message);
    }
  };

  return (
    <div className="container mx-auto p-6">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-gray-800">Informe de ausencias</h1>
        <p className="text-sm text-gray-500">Consulta las ausencias registradas por rango de fechas.</p>
      </div>

      <form onSubmit={handleSearch} className="mb-6 grid gap-4 md:grid-cols-3">
        <div>
          <label className="text-sm font-semibold text-gray-600">Desde</label>
          <input
            type="date"
            value={from}
            onChange={(event) => setFrom(event.target.value)}
            className="mt-1 w-full rounded-lg border border-gray-200 p-2"
          />
        </div>
        <div>
          <label className="text-sm font-semibold text-gray-600">Hasta</label>
          <input
            type="date"
            value={to}
            onChange={(event) => setTo(event.target.value)}
            className="mt-1 w-full rounded-lg border border-gray-200 p-2"
          />
        </div>
        <div className="flex items-end">
          <div className="flex w-full gap-2">
            <button
              type="submit"
              disabled={isLoading}
              className="w-full rounded-lg bg-blue-600 px-4 py-2 text-white hover:bg-blue-700 disabled:opacity-60"
            >
              {isLoading ? 'Buscando...' : 'Buscar'}
            </button>
            <button
              type="button"
              onClick={handleDownloadPdf}
              className="w-full rounded-lg border border-gray-200 px-4 py-2 text-gray-600 hover:bg-gray-50"
            >
              Descargar PDF
            </button>
          </div>
        </div>
      </form>

      {error && <div className="mb-4 rounded-lg bg-red-50 px-4 py-2 text-sm text-red-600">{error}</div>}

      <div className="overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm">
        {isLoading ? (
          <div className="p-6 text-sm text-gray-500">Cargando ausencias...</div>
        ) : records.length === 0 ? (
          <div className="p-6 text-sm text-gray-500">No hay ausencias para el rango seleccionado.</div>
        ) : (
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-semibold uppercase tracking-wider text-gray-500">
                  Empleado
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold uppercase tracking-wider text-gray-500">
                  Inicio
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold uppercase tracking-wider text-gray-500">
                  Fin
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold uppercase tracking-wider text-gray-500">
                  Tipo
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold uppercase tracking-wider text-gray-500">
                  Estado
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold uppercase tracking-wider text-gray-500">
                  Motivo
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {records.map((record) => (
                <tr key={record.id} className="hover:bg-gray-50">
                  <td className="px-6 py-4 text-sm text-gray-700">
                    {record.employeeName || `Empleado ${record.employeeId}`}
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-500">{record.startDate}</td>
                  <td className="px-6 py-4 text-sm text-gray-500">{record.endDate}</td>
                  <td className="px-6 py-4 text-sm text-gray-500">{record.type}</td>
                  <td className="px-6 py-4 text-sm text-gray-500">{record.status}</td>
                  <td className="px-6 py-4 text-sm text-gray-500">{record.reason || '--'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
